import React from "react";
import { MoreVertical } from "lucide-react";
import OverviewCardShell from "./cards/OverviewCardShell";
import AnalyticsMiniBarChart from "./analytics/AnalyticsMiniBarChart";
import AnalyticsMiniLineChart from "./analytics/AnalyticsMiniLineChart";

import { dashboardAnalyticsData } from "../constants";

const AnalyticsPair = ({ label, value }) => (
  <div className="flex items-center justify-between gap-4 text-xs sm:text-sm">
    <span className="  text-[#6B7280]">{label}</span>
    <span className="  font-medium text-[#111827]">
      {value}
    </span>
  </div>
);

const AnalyticsCard = ({ title, children }) => (
  <OverviewCardShell
    title={title}
    action={<MoreVertical size={18} className="text-[#6B7280]" />}
    className="min-h-[275px]"
  >
    {children}
  </OverviewCardShell>
);

const AIAnalyticsSection = () => {
  const { sectionTitle, courses, instructors, engagement } =
    dashboardAnalyticsData;

  return (
    <section className="px-5 pb-8 md:pl-6 pt-6 md:pt-8 md:pr-[34px]">
      <h2 className="mb-4  text-lg sm:text-xl font-bold text-[#111827] ">
        {sectionTitle}
      </h2>

      <div className="grid grid-cols-1 gap-5 xl:grid-cols-3">
        <div>
          <AnalyticsCard title={courses.title}>
            <AnalyticsMiniBarChart
              values={courses.bars}
              labels={courses.labels}
              showAlternateLabels
              barClassName="bg-[#57A8E0]"
            />
          </AnalyticsCard>
          <div className="mt-2 space-y-1 sm:px-4">
            <AnalyticsPair label="Most Popular:" value={courses.mostPopular} />
            <AnalyticsPair label="Trending:" value={courses.trending} />
          </div>
        </div>

        <div>
          <AnalyticsCard title={instructors.title}>
            <AnalyticsMiniBarChart
              values={instructors.bars}
              labels={instructors.labels}
              barColors={instructors.barColors}
              showAllLabels
              labelClassName="-rotate-45 origin-top-left whitespace-nowrap"
            />
          </AnalyticsCard>

          <div className="mt-2 space-y-1 sm:px-4">
            <AnalyticsPair label="Top Rated:" value={instructors.topRated} />
            <AnalyticsPair
              label="Needs Improvement:"
              value={instructors.needsImprovement}
            />
          </div>
        </div>

        <div>
          <AnalyticsCard title={engagement.title}>
            <AnalyticsMiniLineChart
              points={engagement.points}
              labels={engagement.labels}
              showAllLabels
            />
          </AnalyticsCard>

          <div className="mt-2 space-y-1 sm:px-4">
            <AnalyticsPair
              label="Most Engaged:"
              value={engagement.mostEngaged}
            />
            <AnalyticsPair
              label="Least Engaged:"
              value={engagement.leastEngaged}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AIAnalyticsSection;
